import _ from 'lodash';

import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';
import { createEntity } from 'app/entity/EntityActions';
import { postJson } from 'app/common/fetch';
import { EMAIL, NEW_SUBMIT_EMAIL_FORM } from 'app/zapbook/utils/constants';

export const type = 'collectEmail';

export const selectors = buildEntitySelectors(type, sel => {
  sel.email = _.partial(sel.dataItem, EMAIL);
});

export const api = buildEntityApi(type, '/api/v3/email', collectEmailApi => {
  collectEmailApi.submitEmail = data => {
    const { s1, s2, email } = data;
    return postJson(collectEmailApi.collectionEndpoint(`/${s1}/${s2}`), {
      email,
    }).then(() => ({ id: NEW_SUBMIT_EMAIL_FORM }));
  };
});

export const actions = buildEntityActions(
  type,
  selectors,
  api,
  collectEmailActions => {
    collectEmailActions.updateEmail = _.partial(
      collectEmailActions.updateEntityDataItem,
      EMAIL
    );

    collectEmailActions.voteForApp = (messages, id, data) => {
      return (dispatch, getState) => {
        const email = selectors.email(selectors.all.entity(id, getState()));
        return dispatch(
          createEntity(
            type,
            () => ({ ...data, email }),
            api.submitEmail,
            messages,
            id
          )
        );
      };
    };
  }
);
